import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography, Paper } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';

interface DragAndDropFileUploadProps {
  order?: string; 
  onFileSelected: (file: File) => void;
}

export default function DragAndDropFileUpload({ order, onFileSelected }: DragAndDropFileUploadProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setSelectedFile(file);
      onFileSelected(file);
    }
  }, [onFileSelected]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
      'text/csv': ['.csv'],
    },
    multiple: false,
  });

  return (
    <Box sx={{ padding: 2 }}>
      <Paper
        {...getRootProps()}
        sx={{
          width: '900px',
          border: '2px dashed var(--primary-color)',
          backgroundColor: isDragActive ? '#e3f2fd' : '#fafafa',
          textAlign: 'center',
          padding: '20px',
          cursor: 'pointer',
          transition: 'background-color 0.3s ease',
        }}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <Typography variant="body1" color="primary">
            Solte os arquivos aqui...
          </Typography>
        ) : (
          <Typography variant="body1">
            Clique ou arraste para inserir um arquivo
          </Typography>
        )}
      </Paper>

      {/* Exibir arquivo selecionado */}
      {selectedFile && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginTop: 2,
            padding: 1,
            backgroundColor: '#f5f5f5',
            borderRadius: 1,
          }}
        >
          <AttachFileIcon sx={{ marginRight: 1, color: 'gray' }} />
          <Typography variant="body2">{selectedFile.name}</Typography>
        </Box>
      )}
    </Box>
  );
}
